import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetProjectDetailsRPC } from "./getProjectDetailsRPC";

export class GetProjectDetailsRPCClientImpl extends GetProjectDetailsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetProjectDetailsRPC.Request): Promise<LeoRPCResult<GetProjectDetailsRPC.Response, GetProjectDetailsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/GetProjectDetails",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetProjectDetailsRPC.ResponseDTO,
      GetProjectDetailsRPC.Errors.ErrorsDTO,
      GetProjectDetailsRPC.Response,
      GetProjectDetailsRPC.Errors.Errors
    >(
      response,
      "project/GetProjectDetails",
      GetProjectDetailsRPC.Response.fromDTO,
      GetProjectDetailsRPC.Errors.fromDTO
    );
  }
}
